import { useState } from "react";
import { useTheme } from "../contexts/ThemeContext";

export default function CondominioSelector() {
  const { theme } = useTheme();
  const isLight   = theme === "light";

  const condominios = JSON.parse(localStorage.getItem("condominios_contador") || "[]");
  const activeId    = localStorage.getItem("active_condominio_id") || "";
  const [selected, setSelected] = useState(activeId);

  if (condominios.length === 0) return null;

  function handleChange(e) {
    const newId = e.target.value;
    setSelected(newId);
    localStorage.setItem("active_condominio_id", newId);
    window.location.reload();
  }

  return (
    <>
      <style>{`
        .condo-selector {
          background: ${isLight ? "rgba(249,115,22,0.06)" : "rgba(249,115,22,0.08)"};
          border: 1px solid rgba(249,115,22,0.35);
          border-radius: 8px;
          color: #f97316;
          padding: 5px 10px;
          font-size: 0.82rem;
          font-weight: 700;
          outline: none;
          cursor: pointer;
          max-width: 200px;
          min-width: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        @media (max-width: 600px) {
          .condo-selector {
            max-width: 120px;
            font-size: 0.72rem;
            padding: 4px 8px;
          }
        }
      `}</style>
      <select
        className="condo-selector"
        value={selected}
        onChange={handleChange}
        title="Condominio activo"
      >
        {condominios.map(c => (
          <option key={c.id} value={String(c.id)}>{c.nombre}</option>
        ))}
      </select>
    </>
  );
}
